import { Component, Input, OnInit } from '@angular/core';
import { DOWNLOAD_DATA, LOCKED, LITE, HANDSHAKE } from 'src/defaultImages.js';
import { NzModalService } from 'ng-zorro-antd/modal';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { UtilService } from 'src/app/util/util.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { LanguageService } from 'src/app/common/services/language.service';
import { DateService } from 'src/app/common/services/date.service';
import { country } from 'src/app/common/enums/language';
import { CollectionInfrastructureService } from 'src/app/collection-infrastructure/collection-infrastructure.service';
import { MessageService } from 'src/app/common/services/message.service';
import { CollectionInfrastructureModalService } from 'src/app/collection-infrastructure/collection-infrastructure-modal.service';
import { CLIENT_ID } from 'src/app/collection-infrastructure/collection-infrastructure.enums';

@Component({
  selector: 'app-locked-pos',
  templateUrl: './locked-pos.component.html',
  styleUrls: ['./locked-pos.component.css'],
})
export class LockedPosComponent implements OnInit {
  currency: string;
  @Input() popupData: any[];
  paymentDetails: any;
  lastDate;
  currentMonth;
  restaurantId;
  isIndo: boolean = false;
  paymentBody: any;
  isLoading: boolean = false;
  pledge: boolean = false;
  isExpert: boolean = true;
  radioValue: string = 'complete';
  images = {
    LOCKED: LOCKED,
    DOWNLOAD: DOWNLOAD_DATA,
    LITE: LITE,
    HANDSHAKE: HANDSHAKE,
  };
  constructor(
    private _modalService: NzModalService,
    private _localStorage: LocalStorageService,
    private _util: UtilService,
    private _curr: CurrencyService,
    private _collectionInfraService: CollectionInfrastructureService,
    private _ciModalService: CollectionInfrastructureModalService,
    private _lang: LanguageService,
    private _msg: MessageService,
    private _dateService: DateService
  ) {
    this.currency = this._curr.getCurrency();
    this.lastDate = this._dateService.getLastDateOfMonthFormatted()
    this.currentMonth = this._dateService.returnLastDateMonth();
    this.restaurantId = this._localStorage.get('restaurant_id');
  }

  ngOnInit() {
    this.isIndo = this._lang.getDomain() === country.id.domain;
    this.paymentDetails = this.popupData;
    this.paymentBody = [
      {
        restaurant_id: this.restaurantId,
        amount: Math.abs(this.paymentDetails.finalBill),
      },
    ];
  }

  // expert popup
  async talkToExpert() {
    const { TalkExpertFormComponent } = await import(
      /* webpackPrefetch: true */ '../talk-expert-form/talk-expert-form.component'
    );
    const modal = this._modalService.create({
      nzClosable: false,
      nzContent: TalkExpertFormComponent,
      nzBodyStyle: { padding: '20px' },
      nzStyle: { top: '20px' },
      nzFooter: null,
      nzWidth: 500,
      nzMaskClosable: false,
    });

    modal.afterClose.subscribe((result: any) => {
      if ((result || {}).success === 1) {
        this.isExpert = true;
      }
    });
  }

  download() {
    this.isLoading = true; // Set isLoading to true to show the loader

    this._collectionInfraService
      .download(this.restaurantId)
      .then((response) => {
        // Handle the successful download here
        this.isLoading = false; // Set isLoading to false to hide the loader
      })
      .catch((error) => {
        // Handle the error here
        this.isLoading = false; // Set isLoading to false to hide the loader
      });
  }
  explore() {
    this.pledge = true;
  }
  async askForReocurrInfoandPay() {
    const modal = await this._ciModalService.openPaymentMethodModal({
      paymentPayload: this.paymentBody,
      client_id: CLIENT_ID.NEGATIVE_BALANCE,
    });
    modal.afterClose.subscribe((response) => {
      const res = (response || {}).data || {};
      if (res.status === 1) {
        this._msg.showSuccess(res.message);
      }
    });
  }
}
